import { render, staticRenderFns } from "./UserRiskDialog.vue?vue&type=template&id=35bc9187&scoped=true&"
import script from "./UserRiskDialog.vue?vue&type=script&lang=js&"
export * from "./UserRiskDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserRiskDialog.vue?vue&type=style&index=0&id=35bc9187&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bc9187",
  null
  
)

export default component.exports